export interface IPortalTimelineWidgetState {
    introText: string,
    items: IPortalTimelineItem[],
    labels: IPortalTimelineWidgetLabels
    selectedItemIndex: number,
    selectedItem: IPortalTimelineItem,
    currentlyOpenTopic: number
    selectedTopic: IPortalTopic,
}

export interface IPortalTimelineWidgetLabels {
    visit: string;
    portalInstructions: string;
    swipeIndicator: string;
}

export interface IPortalTimelineItem {
    title: string,
    icon: string,
    topics: IPortalTopic[],
}

export interface IPortalTopic {
    slug: string,
    url: string,
    title: string,
    introText: string,
    subtopics: IPortalSubtopic[],
}

export interface IPortalSubtopic {
    title: string,
    introText: string,
    bodyText: string,
}

export class PortalTimelineWidgetState implements IPortalTimelineWidgetState {
    currentlyOpenTopic: number = -1
    introText: string = '';
    items: IPortalTimelineItem[] = [];
    selectedItemIndex: number = 0;
    selectedItem: IPortalTimelineItem = {icon: "", title: "", topics: []}
    selectedTopic: IPortalTopic = {introText: "", slug: "", subtopics: [], title: "", url: ""}
    labels: IPortalTimelineWidgetLabels = {portalInstructions: "", swipeIndicator: "", visit: ""}
}
